import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const CALENDLY_URL = "https://calendly.com/favorstudio/new-meeting";
export const CONTACT_EMAIL = "contact@favorstudio.agency";

export const apiClient = axios.create({
  baseURL: API,
  timeout: 60000,
});

export async function sendChat(sessionId, message) {
  const res = await apiClient.post("/chat", {
    session_id: sessionId,
    message,
  });
  return res.data;
}

export async function submitLead(payload) {
  const res = await apiClient.post("/leads", payload);
  return res.data;
}
